module.exports = __webpack_public_path__ + "static/media/cavity-math_remember.e087af9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/cavity-math_remember.mp3
// module id = 1+25
// module chunks = 0